<template>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="350" :nudge-bottom="18" offset-y transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mr-3" text icon v-bind="attrs" v-on="on" :ripple="false">
        <v-badge :content="unread" :value="unread" color="red"><v-icon class="text--secondary" size="24">mdi-bell-ring</v-icon></v-badge>
      </v-btn>
    </template>
    <v-responsive class="overflow-y-auto" :height="editable.length ? '600' : '400'">
      <v-subheader class="pl-5 subtitle-1 text--secondary font-weight-medium">Notificaciones</v-subheader>
      <v-divider class="ma-0 grey lighten-3" />
      <template v-if="editable.length">
        <v-row class="mx-0" v-for="(notification, index) in editable" :key="index" align="center" no-gutters>
          <v-col class="pa-0">
            <v-skeleton-loader v-if="loading" transition="fade-transition" type="list-item-avatar-three-line" />
            <template v-else>
              <v-hover v-slot:default="{ hover }" open-delay="200">
                <v-lazy v-model="notification.isActiveMsg" :value="pag" :options="{ threshold: .5 }" min-height="80" transition="fade-transition">
                  <v-row :class="hover ? 'grey lighten-4 pt-2' : 'pt-2'" align="start" justify="center">
                    <v-col cols="10" class="py-1 px-0">
                      <v-row align="center" justify="center" no-gutters>
                        <v-col cols="11" style="line-height: 10px">
                          <span class="subtitle-2 secondary--text font-weight-medium">{{notification.title}}</span>
                          <span class="d-block subtitle-2">{{notification.message}}</span>
                        </v-col>
                        <v-col cols="1" class="mx-0">
                          <v-icon v-if="notification.status === 'unread'" color="primary" small>mdi-circle</v-icon>
                        </v-col>
                      </v-row>
                      <v-row class="mt-n2" align="center" justify="center" no-gutters>
                        <v-col cols="7" class="ml-0 py-2">
                          <v-chip v-if="notification.model === 'invoice'" color="primary" x-small text-color="white">Facturas</v-chip>
                          <v-chip v-else-if="notification.model === 'payment'" color="primary" x-small text-color="white">Pagos</v-chip>
                          <v-chip v-else-if="notification.model === 'subscription'" color="primary" x-small text-color="white">Suscripciones</v-chip>
                          <span :class="`${ notification.status === 'unread' ? 'primary--text' : 'secondary--text' } caption font-weight-medium pl-3`">{{notification.created | dateConditional}}</span>
                        </v-col>
                        <v-col cols="5" class="py-0 text-center">
                          <template v-if="hover">
                            <v-btn class="caption" v-if="notification.status === 'unread'" @click="updateStatusNotification(notification.id, notification.status = 'read')" text><v-icon class="mr-1" color="primary" small>mdi-check</v-icon>Marcar como leido</v-btn>
                            <v-btn class="caption" v-if="notification.status === 'read'" @click="updateStatusNotification(notification.id, notification.status = 'unread')" text><v-icon class="mr-1" color="primary" small>mdi-check</v-icon>Marcar como no leido</v-btn>
                          </template>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-lazy>
              </v-hover>
              <v-divider class="mx-0 grey lighten-3" />
            </template>
          </v-col>
        </v-row>
        <v-col class="py-1 text-center" v-if="!loading && totalPages !== page">
          <v-row align="center" justify="center">
            <v-btn @click="seeMore()" text color="primary" :ripple="false">Ver más</v-btn>
          </v-row>
        </v-col>
      </template>
      <v-row v-else align="center" justify="center" style="min-height: 300px">
        <v-col class="mx-5 text-center">
          <v-icon class="mb-5" color="secondary" size="40">mdi-bell-off</v-icon>
          <span class="d-block body-1 text--secondary font-weight-medium">Aún no tienes notificaciones</span>
        </v-col>
      </v-row>
    </v-responsive>
  </v-menu>
</template>
<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import ListViewMixin from '@/mixins/ListViewMixin'
import cloneDeep from 'lodash/cloneDeep'
export default {
  mixins: [
    GenericViewMixin,
    ListViewMixin
  ],
  data: () => ({
    pag: 1,
    menu: false,
    isActiveMsg: false,
    loading: false,
    editable: [{
      status: 'read'
    }],
    notificationsPage: []
  }),
  computed: {
    ...mapState({
      notificationsList: state => state.accounts.notificationsList,
      count: state => state.accounts.notificationsCount,
      memberID: state => state.auth.account.me
    }),
    unread () {
      return this.editable.filter(notification => {
        return notification.status === 'unread'
      }).length
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    /**
     * Pusher
     * @param{number}  eventName - add member ID in subscribe channel pusher
     * @function callback - function to be called whenever the event is triggered.
    */
    var channel = this.$pusher.subscribe(this.memberID)
    channel.bind('new_notification', (data) => {
      // this.getList()
    })
  },
  methods: {
    getList () {
      // this.loading = true
      // this.$store.dispatch('accounts/LIST', {
      //   resource: 'notifications',
      //   id: this.$store.state.auth.account.id
      // })
      // .then(() => {
      //   this.editable = cloneDeep(this.notificationsList)
      // })
      // .finally(() => {
      //   this.loading = false
      // })
    },
    updateStatusNotification (id, status) {
      const payload = {
        status: status
      }
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'notifications',
        payload: payload,
        id: id
      })
    },
    /**
     * Pagination - load more notifications
     * @function
     * The result of the request /page is added to this.editable (clone of notificationsList)
    */
    seeMore () {
      this.pag++
      if (this.pag > 0 && this.pag <= this.totalPages) {
        this.$store.dispatch('accounts/LIST', {
          resource: 'notifications',
          query: Object.assign({}, this.$route.query, {page: this.pag})
        })
        .then((response) => {
          const notification = response.data.results
          this.notificationsPage = cloneDeep(notification)
          this.editable = [...this.editable, ...this.notificationsPage]
        })
      }
    }
  }
}
</script>
